import React from 'react';
import {Col} from 'react-grid-system';
import Heading from './Heading';
import Divider from './Divider';
import Paragraph from './Paragraph';

interface States {
}

interface Props {
    title: String;
    description: String;
}

class SectionDescription extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <Col lg={6}>
                <Heading
                    text={this.props.title}/>
                <Divider className="divider"/>
                <Paragraph
                    text={this.props.description}/>
            </Col>
        )
    }
}

export default SectionDescription;
